<template>
  <div id="app">
    <!-- @mousemove="isDo()" -->
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      timeOut: 30 * 60 * 1000,// 设置超时时间： 30分
      lastTime: null, // 鼠标最后一次点击时间
      currentTime: null, // 当前时间
      check_time: 30 * 60 * 1000, //探测间隔时间
      timer: null,  // 定时器
    };
  },
  mounted() {
    this.currentTime = new Date().getTime();
    this.lastTime = new Date().getTime();
    // 监听鼠标点击时间，获取最后一次点击时间
    window.document.onmousemove = (event) => {
      if (Lockr.get("sign") == 'djb') {
        console.log('重置最后一次点击时间');
        this.lastTime = new Date().getTime();
      }
    }
    this.onload();
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    // 间隔特定时间检测系统无操作时间
    onload() {
      this.timer = window.setInterval(this.isDo, this.check_time)
    },
    isDo() {
      if (Lockr.get("sign") == 'djb') {
        this.currentTime = new Date().getTime(); //记录这次点击的时间
        if (this.currentTime - this.lastTime > this.timeOut) {  //判断上次最后一次点击的时间和这次点击的时间间隔是否大于10分钟
          // 这里写状态已过期后执行的操作
          _g.toast("warning", '账号登录已过期,请重新登陆');
          Lockr.flush()
          router.push('/login')
        } else {
          console.log('轮询');
          // this.lastTime = new Date().getTime(); //如果在10分钟内点击，则把这次点击的时间记录覆盖掉之前存的最后一次点击的时间
        }
      }
    }
  },
  // created() {
  //   this.lastTime = new Date().getTime();   //网页第一次打开时，记录当前时间
  // }
}
</script>

<style lang="scss">
@import "assets/css/font-awesome.min.css";
body {
  margin: 0px;
  padding: 0px;
  /*background: #2f4050;*/
  width: 100%;
  height: 100%;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
}
#app {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
}
.vux-pop-in-enter-active,
.vux-pop-in-leave-active {
  will-change: transform;
  transition: all 200ms;
  height: auto;
  width: 100%;
  position: absolute;
  backface-visibility: hidden;
  perspective: 1000;
}
.vux-pop-in-enter {
  opacity: 0;
  transform: translate3d(5%, 0, 0);
}
.vux-pop-in-leave-active {
  opacity: 0;
  transform: translate3d(0%, 0, 0);
}
</style>
